import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import moment from "moment";
import { formatAmount } from "../../../utility/CommonFunctions";
import CreateTransactionModal from "./CreateTransationModal";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import EditIcon from "../../../components/Icons/EditIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { useSelector } from "react-redux";
import CreateDebitNoteModal from "./CreateDebitNoteModal";
import { Spinner, Table } from "reactstrap";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import MainHeading from "../../../components/comman/MainHeading";
import DownloadIcon from "../../../components/Icons/DownloadIcon";
import UpdateBillingDetailsModal from "./UpdateBillingDetailsModal";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../components/Icons/PlusIcon";

export default function InvoiceDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [invoiceDetail, setInvoiceDetail] = useState({});
  const [months, setMonths] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedId, setSelectedId] = useState("");
  const [editData, setEditData] = useState("");
  const [editDataForDebitNote, setEditDataForDebitNote] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);

  const [debitNoteModal, setDebitNoteModal] = useState(false);
  const toggleDebitNoteModal = () => {
    setDebitNoteModal(!debitNoteModal);
  };
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [docModal, setDocModal] = useState(false);
  const toggleDocModal = () => {
    setDocModal(!docModal);
  };
  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const [updateBillingModal, setUpdateBillingModal] = useState(false);
  const toggleUpdateBillingModal = () => {
    setUpdateBillingModal(!updateBillingModal);
  };

  useEffect(() => {
    GetInvoiceDetail();
  }, []);

  const GetInvoiceDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_invoice_detail + `?invoiceId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setInvoiceDetail(response?.data);
        if (response?.data?.month) {
          try {
            let parsedMonths =
              typeof response?.data?.month === "string"
                ? JSON.parse(response?.data?.month)
                : response?.data?.month;
            setMonths(Array.isArray(parsedMonths) ? parsedMonths : []);
          } catch (e) {
            setMonths([]);
          }
        }
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setDocModal(true);
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggleDeleteModal();
  };

  const HandleUpdate = (data) => {
    if (data?.type === "debitNote") {
      setEditDataForDebitNote(data);
      toggleDebitNoteModal();
    } else {
      setEditData(data);
      toggleModal();
    }
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_transaction + `?transactionId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggleDeleteModal();
        GetInvoiceDetail();
      } else {
        toast.error(response?.message);
        toggleDeleteModal();
      }
    });
  };

  const HandleDownloadInvoice = async () => {
    const API = `${apiUrl?.generate_invoice}?invoiceId=${id}`;

    try {
      setDownloadLoading(true);
      const response = await callApi(API, { method: "GET" });
      setDownloadLoading(false);
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Invoice_${
          invoiceDetail?.invoiceNumber || "Invoice"
        }.pdf`;

        const fileResponse = await fetch(fileUrl);

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        toast.error(response?.message || "Failed to fetch file URL");
      }
    } catch (err) {
      console.error(err);
      toast.error("Download failed. Please try again.");
    }
  };

  // Calculations for reconciliation
  const hasFinancials = Boolean(
    invoiceDetail?.grossAmount || invoiceDetail?.receivedAmount
  );
  const rawDiff =
    +invoiceDetail?.grossAmount - +invoiceDetail?.receivedAmount;
  const isCleared = Math.abs(rawDiff) <= 1;
  const balanceAmount = hasFinancials
    ? isCleared
      ? 0
      : rawDiff.toFixed(2)
    : 0;
  const isBalancePending = !isCleared && rawDiff > 1;
  const totalItemsCount = invoiceDetail?.invoiceitems?.length || 0;

  const sortedItems = [...(invoiceDetail?.invoiceitems || [])].sort((a, b) =>
    (a?.workorderitem?.item || a?.item || "").localeCompare(
      b?.workorderitem?.item || b?.item || ""
    )
  );

  return (
    <>
      {(isLoading || downloadLoading) && <BgBlurLoader />}
      <div className="content container-fluid pb-5">
        {/* Main Header with Actions */}
        <MainHeading title="Invoice Detail" showBackButton={true}>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <button
              className="btn btn-outline-primary d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-2"
              onClick={() => toggleUpdateBillingModal()}
            >
              <EditIcon />
              <span>Update Billing Details</span>
            </button>
            <button
              className="btn btn-primary d-inline-flex align-items-center gap-1.5 fw-semibold px-3.5 py-2 text-white shadow-sm"
              style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
              onClick={HandleDownloadInvoice}
              disabled={
                invoiceDetail?.billedToName === null &&
                invoiceDetail?.shippedToName == null
              }
            >
              {downloadLoading ? (
                <Spinner size="sm" />
              ) : (
                <span className="me-1">
                  <DownloadIcon />
                </span>
              )}
              <span>Download Invoice</span>
            </button>
          </div>
        </MainHeading>

        {/* Master Summary Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            {/* Top Identity Strip */}
            <div
              className="d-flex align-items-start justify-content-between flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 p-2.5 flex-shrink-0"
                  style={{
                    background: "#eff6ff",
                    color: "#2563eb",
                    width: "48px",
                    height: "48px",
                    fontSize: "22px",
                  }}
                >
                  🧾
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h3
                      className="mb-0 fw-bold text-dark"
                      style={{ letterSpacing: "-0.02em", fontSize: "1.35rem" }}
                    >
                      {invoiceDetail?.invoiceNumber || "--"}
                    </h3>
                    {invoiceDetail?.workorder?.workOrderNumber && (
                      <span
                        className="badge rounded-pill px-2.5 py-1 fw-semibold d-inline-flex align-items-center gap-1 cursor-pointer"
                        style={{
                          fontSize: "12px",
                          background: "#eff6ff",
                          color: "#1d4ed8",
                          border: "1px solid #bfdbfe",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate(
                            `${RoutesLink.work_order_detail}/${invoiceDetail?.workorder?.id}`
                          )
                        }
                        title="Click to view Work Order"
                      >
                        <span>🏗️</span>
                        <span>
                          WO: {invoiceDetail?.workorder?.workOrderNumber}
                        </span>
                      </span>
                    )}
                    <span
                      className={`badge rounded-pill px-2.5 py-1 fw-semibold ${
                        isCleared
                          ? "bg-success-subtle text-success border border-success-subtle"
                          : isBalancePending
                          ? "bg-warning-subtle text-warning-emphasis border border-warning-subtle"
                          : "bg-light text-secondary border"
                      }`}
                      style={{ fontSize: "12px" }}
                    >
                      {isCleared
                        ? "Paid / Settled"
                        : isBalancePending
                        ? "Payment Pending"
                        : "Active"}
                    </span>
                  </div>

                  <div className="text-secondary small mt-1 d-flex align-items-center gap-2 flex-wrap">
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📍</span>
                      <span>
                        <strong>Site:</strong>{" "}
                        {invoiceDetail?.workorder?.site?.name || "--"}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>🏢</span>
                      <span>
                        <strong>Customer:</strong>{" "}
                        {invoiceDetail?.workorder?.site?.customer?.name || "--"}
                      </span>
                    </span>
                    <span>•</span>
                    <span className="d-inline-flex align-items-center gap-1">
                      <span>📅</span>
                      <span>
                        <strong>Date:</strong>{" "}
                        {invoiceDetail?.invoiceDate
                          ? moment(invoiceDetail.invoiceDate).format(
                              "DD MMM YYYY"
                            )
                          : "--"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              {/* Quick Quantitative KPIs */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "120px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Net Receivable
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(invoiceDetail?.grossAmount) || "--"}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "115px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Received
                  </div>
                  <div
                    className="fw-bold text-success"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(invoiceDetail?.receivedAmount || 0)}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: isBalancePending ? "#fff1f2" : "#f0fdf4",
                    border: `1px solid ${
                      isBalancePending ? "#fecdd3" : "#bbf7d0"
                    }`,
                    minWidth: "115px",
                  }}
                >
                  <div
                    className="text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                      color: isBalancePending ? "#e11d48" : "#16a34a",
                    }}
                  >
                    Balance Due
                  </div>
                  <div
                    className="fw-bold"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                      color: isBalancePending ? "#be123c" : "#15803d",
                    }}
                  >
                    {formatAmount(balanceAmount)}
                  </div>
                </div>

                <div
                  className="px-3.5 py-2 rounded-2 text-center"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minWidth: "120px",
                  }}
                >
                  <div
                    className="text-secondary text-uppercase"
                    style={{
                      fontSize: "10.5px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Total Amount
                  </div>
                  <div
                    className="fw-bold text-dark"
                    style={{
                      fontSize: "16px",
                      lineHeight: "1.2",
                      marginTop: "2px",
                    }}
                  >
                    {formatAmount(invoiceDetail?.totalAmount) || "--"}
                  </div>
                </div>
              </div>
            </div>

            {/* Key Information Grid */}
            <div className="row g-3 pt-3">
              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Work Order No.
                  </div>
                  {invoiceDetail?.workorder?.workOrderNumber ? (
                    <div
                      className="fw-semibold text-primary text-truncate cursor-pointer"
                      title="Click to view Work Order"
                      style={{ fontSize: "13.5px", cursor: "pointer" }}
                      onClick={() =>
                        navigate(
                          `${RoutesLink.work_order_detail}/${invoiceDetail?.workorder?.id}`
                        )
                      }
                    >
                      {invoiceDetail?.workorder?.workOrderNumber} ↗
                    </div>
                  ) : (
                    <div
                      className="fw-semibold text-dark"
                      style={{ fontSize: "13.5px" }}
                    >
                      --
                    </div>
                  )}
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Linked Contract
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Customer
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={invoiceDetail?.workorder?.site?.customer?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {invoiceDetail?.workorder?.site?.customer?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    Client Account
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    GST Type
                  </div>
                  <div
                    className="fw-semibold text-dark"
                    style={{ fontSize: "13.5px" }}
                  >
                    {invoiceDetail?.workorder?.gstType || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Tax Classification
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Site Name
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={invoiceDetail?.workorder?.site?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {invoiceDetail?.workorder?.site?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Operating Location
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Billing Months
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={months?.length > 0 ? months.join(", ") : "--"}
                    style={{ fontSize: "13.5px" }}
                  >
                    {months?.length > 0 ? months.join(", ") : "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5"
                    style={{ fontSize: "11px" }}
                  >
                    Invoice Coverage
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Billed To
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={invoiceDetail?.billedToName}
                    style={{ fontSize: "13.5px" }}
                  >
                    {invoiceDetail?.billedToName || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    {invoiceDetail?.billedToGst
                      ? `GST: ${invoiceDetail.billedToGst}`
                      : "Billing Entity"}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Shipped To
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={invoiceDetail?.shippedToName}
                    style={{ fontSize: "13.5px" }}
                  >
                    {invoiceDetail?.shippedToName || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    {invoiceDetail?.shippedToGst
                      ? `GST: ${invoiceDetail.shippedToGst}`
                      : "Shipping Entity"}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div
                  className="p-3 rounded-2 h-100"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    className="text-muted text-uppercase mb-1"
                    style={{
                      fontSize: "11px",
                      fontWeight: 700,
                      letterSpacing: "0.05em",
                    }}
                  >
                    Created By
                  </div>
                  <div
                    className="fw-semibold text-dark text-truncate"
                    title={invoiceDetail?.user?.name}
                    style={{ fontSize: "13.5px" }}
                  >
                    {invoiceDetail?.user?.name || "--"}
                  </div>
                  <div
                    className="text-secondary small mt-0.5 text-truncate"
                    style={{ fontSize: "11px" }}
                  >
                    {invoiceDetail?.user?.designation?.name
                      ? `(${invoiceDetail.user.designation.name})`
                      : "Invoice Creator"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Invoice Items Table Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                style={{ background: "#f1f5f9", color: "#475569" }}
              >
                <span
                  style={{
                    fontSize: "15px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 1,
                  }}
                >
                  📦
                </span>
              </div>
              <h5
                className="mb-0 fw-bold text-dark"
                style={{ fontSize: "15px" }}
              >
                Invoice Line Items
              </h5>
            </div>
            <span
              className="badge bg-light text-secondary border px-3 py-1.5 rounded-pill"
              style={{ fontSize: "12px", fontWeight: 600 }}
            >
              {totalItemsCount} {totalItemsCount === 1 ? "Item" : "Items"}
            </span>
          </div>

          <div className="table-responsive">
            <table
              className="table align-middle mb-0"
              style={{ borderCollapse: "separate", borderSpacing: "0" }}
            >
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  <th
                    style={{
                      width: "50px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      minWidth: "200px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Item
                  </th>
                  <th
                    style={{
                      width: "120px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    HSN Code
                  </th>
                  <th
                    style={{
                      width: "100px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Quantity
                  </th>
                  <th
                    style={{
                      width: "90px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Unit
                  </th>
                  <th
                    className="text-end"
                    style={{
                      width: "120px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Rate
                  </th>
                  <th
                    className="text-end"
                    style={{
                      width: "130px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Taxable Amount
                  </th>
                  {invoiceDetail?.workorder?.gstType === "IGST" && (
                    <th
                      className="text-end"
                      style={{
                        width: "140px",
                        padding: "12px 16px",
                        fontSize: "11px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        color: "#64748b",
                      }}
                    >
                      IGST
                    </th>
                  )}
                  {invoiceDetail?.workorder?.gstType === "CGST + SGST" && (
                    <>
                      <th
                        className="text-end"
                        style={{
                          width: "130px",
                          padding: "12px 16px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        CGST
                      </th>
                      <th
                        className="text-end"
                        style={{
                          width: "130px",
                          padding: "12px 16px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.05em",
                          color: "#64748b",
                        }}
                      >
                        SGST
                      </th>
                    </>
                  )}
                  <th
                    className="text-end"
                    style={{
                      width: "140px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Total Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedItems?.length > 0 ? (
                  sortedItems.map((item, index) => {
                    const gstRate = item?.workorderitem?.gst || 0;
                    const gstAmount = ((item?.taxableAmount || 0) * gstRate) / 100;
                    const halfGst = gstAmount / 2;
                    return (
                      <tr
                        key={item.id || index}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                      >
                        <td
                          style={{
                            padding: "14px 16px",
                            fontSize: "13px",
                            color: "#94a3b8",
                            fontWeight: 600,
                          }}
                        >
                          {index + 1}
                        </td>
                        <td style={{ padding: "14px 16px" }}>
                          <div
                            className="fw-semibold text-dark"
                            style={{ fontSize: "13.5px" }}
                          >
                            {item?.workorderitem?.item || item?.item || "--"}
                          </div>
                        </td>
                        <td
                          style={{
                            padding: "14px 16px",
                            fontSize: "13px",
                            color: "#475569",
                          }}
                        >
                          {item?.workorderitem?.hsnCode ||
                            item?.hsnCode ||
                            "--"}
                        </td>
                        <td
                          style={{
                            padding: "14px 16px",
                            fontSize: "13.5px",
                            fontWeight: 500,
                            color: "#0f172a",
                          }}
                        >
                          {item?.quantity || "--"}
                        </td>
                        <td style={{ padding: "14px 16px" }}>
                          <span
                            className="badge rounded-pill bg-light text-secondary border px-2 py-0.5"
                            style={{ fontSize: "11.5px" }}
                          >
                            {item?.workorderitem?.unit || "--"}
                          </span>
                        </td>
                        <td
                          className="text-end"
                          style={{
                            padding: "14px 16px",
                            fontSize: "13px",
                            color: "#475569",
                          }}
                        >
                          {formatAmount(item?.workorderitem?.rate)}
                        </td>
                        <td
                          className="text-end"
                          style={{
                            padding: "14px 16px",
                            fontSize: "13.5px",
                            color: "#0f172a",
                            fontWeight: 600,
                          }}
                        >
                          {formatAmount(item?.taxableAmount)}
                        </td>

                        {invoiceDetail?.workorder?.gstType === "IGST" && (
                          <td
                            className="text-end"
                            style={{
                              padding: "14px 16px",
                              fontSize: "13px",
                              color: "#475569",
                            }}
                          >
                            <div>{formatAmount(gstAmount)}</div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "11px" }}
                            >
                              ({gstRate}%)
                            </div>
                          </td>
                        )}

                        {invoiceDetail?.workorder?.gstType ===
                          "CGST + SGST" && (
                          <>
                            <td
                              className="text-end"
                              style={{
                                padding: "14px 16px",
                                fontSize: "13px",
                                color: "#475569",
                              }}
                            >
                              <div>{formatAmount(halfGst)}</div>
                              <div
                                className="text-muted"
                                style={{ fontSize: "11px" }}
                              >
                                ({gstRate / 2}%)
                              </div>
                            </td>
                            <td
                              className="text-end"
                              style={{
                                padding: "14px 16px",
                                fontSize: "13px",
                                color: "#475569",
                              }}
                            >
                              <div>{formatAmount(halfGst)}</div>
                              <div
                                className="text-muted"
                                style={{ fontSize: "11px" }}
                              >
                                ({gstRate / 2}%)
                              </div>
                            </td>
                          </>
                        )}

                        <td
                          className="text-end"
                          style={{
                            padding: "14px 16px",
                            fontSize: "13.5px",
                            color: "#0f172a",
                            fontWeight: 700,
                          }}
                        >
                          {formatAmount(item?.totalAmount)}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={
                        invoiceDetail?.workorder?.gstType === "CGST + SGST"
                          ? 10
                          : invoiceDetail?.workorder?.gstType === "IGST"
                          ? 9
                          : 8
                      }
                      className="text-center py-4 text-muted small fw-bold"
                    >
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
              {sortedItems?.length > 0 && (
                <tfoot
                  style={{
                    background: "#f8fafc",
                    borderTop: "2px solid #e2e8f0",
                  }}
                >
                  <tr className="fw-bold">
                    <td
                      colSpan={6}
                      className="text-start"
                      style={{
                        padding: "12px 16px",
                        fontSize: "13px",
                        color: "#475569",
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                      }}
                    >
                      Subtotal / Line Totals:
                    </td>
                    <td
                      className="text-end"
                      style={{
                        padding: "12px 16px",
                        fontSize: "13.5px",
                        color: "#0f172a",
                      }}
                    >
                      {formatAmount(invoiceDetail?.taxableAmount)}
                    </td>

                    {invoiceDetail?.workorder?.gstType === "IGST" && (
                      <td
                        className="text-end"
                        style={{
                          padding: "12px 16px",
                          fontSize: "13.5px",
                          color: "#0f172a",
                        }}
                      >
                        {formatAmount(
                          (invoiceDetail?.totalAmount || 0) -
                            (invoiceDetail?.taxableAmount || 0)
                        )}
                      </td>
                    )}

                    {invoiceDetail?.workorder?.gstType === "CGST + SGST" && (
                      <>
                        <td
                          className="text-end"
                          style={{
                            padding: "12px 16px",
                            fontSize: "13.5px",
                            color: "#0f172a",
                          }}
                        >
                          {formatAmount(
                            ((invoiceDetail?.totalAmount || 0) -
                              (invoiceDetail?.taxableAmount || 0)) /
                              2
                          )}
                        </td>
                        <td
                          className="text-end"
                          style={{
                            padding: "12px 16px",
                            fontSize: "13.5px",
                            color: "#0f172a",
                          }}
                        >
                          {formatAmount(
                            ((invoiceDetail?.totalAmount || 0) -
                              (invoiceDetail?.taxableAmount || 0)) /
                              2
                          )}
                        </td>
                      </>
                    )}

                    <td
                      className="text-end"
                      style={{
                        padding: "12px 16px",
                        fontSize: "13.5px",
                        color: "#0f172a",
                        fontWeight: 700,
                      }}
                    >
                      {formatAmount(invoiceDetail?.totalAmount)}
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>

        {/* Financial Summary & Settlement Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div className="card-body p-4">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap gap-3 pb-3 border-bottom"
              style={{ borderColor: "#f1f5f9" }}
            >
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "18px" }}>💰</span>
                <h5
                  className="mb-0 fw-bold text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Financial Breakdown & Settlement
                </h5>
              </div>
              <div>
                <span className="text-secondary small fw-medium">
                  All amounts in INR (₹)
                </span>
              </div>
            </div>

            <div className="row g-4 pt-3">
              {/* Left Column: Settlement Progress Card */}
              <div className="col-12 col-lg-6">
                <div
                  className="p-3.5 rounded-3 h-100 d-flex flex-column justify-content-between"
                  style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}
                >
                  <div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <span
                        className="fw-bold text-dark"
                        style={{ fontSize: "13.5px" }}
                      >
                        Receipt & Recovery Status
                      </span>
                      <span
                        className={`badge rounded-pill px-2.5 py-1 ${
                          isCleared
                            ? "bg-success text-white"
                            : isBalancePending
                            ? "bg-warning-subtle text-warning-emphasis border border-warning-subtle"
                            : "bg-light text-secondary border"
                        }`}
                        style={{ fontSize: "11px", fontWeight: 600 }}
                      >
                        {isCleared
                          ? "Fully Settled"
                          : isBalancePending
                          ? "Payment Pending"
                          : "In Progress"}
                      </span>
                    </div>

                    <div className="row g-3">
                      <div className="col-6">
                        <div className="p-3 rounded-2 bg-white border">
                          <div
                            className="text-secondary small mb-1"
                            style={{ fontSize: "11px", fontWeight: 700 }}
                          >
                            TOTAL RECEIVED
                          </div>
                          <div
                            className="fw-bold text-success"
                            style={{ fontSize: "16px" }}
                          >
                            {formatAmount(invoiceDetail?.receivedAmount || 0)}
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="p-3 rounded-2 bg-white border">
                          <div
                            className="text-secondary small mb-1"
                            style={{ fontSize: "11px", fontWeight: 700 }}
                          >
                            BALANCE REMAINING
                          </div>
                          <div
                            className={`fw-bold ${
                              isBalancePending ? "text-danger" : "text-success"
                            }`}
                            style={{ fontSize: "16px" }}
                          >
                            {formatAmount(balanceAmount)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="mt-4 pt-2">
                    <div
                      className="d-flex justify-content-between small text-muted mb-1.5"
                      style={{ fontSize: "11.5px" }}
                    >
                      <span className="fw-medium">Recovery Percentage</span>
                      <span className="fw-bold text-dark">
                        {invoiceDetail?.grossAmount &&
                        +invoiceDetail?.grossAmount > 0
                          ? `${Math.min(
                              100,
                              Math.round(
                                ((+invoiceDetail?.receivedAmount || 0) /
                                  +invoiceDetail?.grossAmount) *
                                  100
                              )
                            )}%`
                          : "0%"}
                      </span>
                    </div>
                    <div
                      className="progress"
                      style={{ height: "7px", backgroundColor: "#e2e8f0" }}
                    >
                      <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{
                          width: `${
                            invoiceDetail?.grossAmount &&
                            +invoiceDetail?.grossAmount > 0
                              ? Math.min(
                                  100,
                                  Math.round(
                                    ((+invoiceDetail?.receivedAmount || 0) /
                                      +invoiceDetail?.grossAmount) *
                                      100
                                  )
                                )
                              : 0
                          }%`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column: Calculations */}
              <div className="col-12 col-lg-6">
                <div className="d-flex flex-column gap-2">
                  <div
                    className="d-flex align-items-center justify-content-between p-2.5 rounded-2"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <span
                      className="text-secondary fw-semibold"
                      style={{ fontSize: "13.5px" }}
                    >
                      Taxable Amount:
                    </span>
                    <span
                      className="fw-bold text-dark"
                      style={{ fontSize: "14.5px" }}
                    >
                      {formatAmount(invoiceDetail?.taxableAmount) || "--"}
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-between p-2.5 rounded-2"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <span
                      className="text-secondary fw-semibold"
                      style={{ fontSize: "13.5px" }}
                    >
                      GST (
                      {invoiceDetail?.workorder?.gstType || "Tax"}):
                    </span>
                    <span
                      className="fw-bold text-success"
                      style={{ fontSize: "14.5px" }}
                    >
                      {formatAmount(
                        (invoiceDetail?.totalAmount || 0) -
                          (invoiceDetail?.taxableAmount || 0)
                      )}
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-between p-2.5 rounded-2"
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                    }}
                  >
                    <span
                      className="text-secondary fw-semibold"
                      style={{ fontSize: "13.5px" }}
                    >
                      Total Invoice Amount:
                    </span>
                    <span
                      className="fw-bold text-dark"
                      style={{ fontSize: "14.5px" }}
                    >
                      {formatAmount(invoiceDetail?.totalAmount) || "--"}
                    </span>
                  </div>

                  {Boolean(invoiceDetail?.tdsAmount) && (
                    <div
                      className="d-flex align-items-center justify-content-between p-2.5 rounded-2"
                      style={{
                        background: "#fef2f2",
                        border: "1px solid #fecdd3",
                      }}
                    >
                      <span
                        className="text-danger fw-semibold"
                        style={{ fontSize: "13.5px" }}
                      >
                        Less: TDS{" "}
                        {invoiceDetail?.tdsPercentage
                          ? `(${invoiceDetail.tdsPercentage}%)`
                          : ""}
                        :
                      </span>
                      <span
                        className="fw-bold text-danger"
                        style={{ fontSize: "14.5px" }}
                      >
                        - {formatAmount(invoiceDetail?.tdsAmount)}
                      </span>
                    </div>
                  )}

                  {Boolean(invoiceDetail?.rententionAmount) && (
                    <div
                      className="d-flex align-items-center justify-content-between p-2.5 rounded-2"
                      style={{
                        background: "#fef2f2",
                        border: "1px solid #fecdd3",
                      }}
                    >
                      <span
                        className="text-danger fw-semibold"
                        style={{ fontSize: "13.5px" }}
                      >
                        Less: Retention{" "}
                        {invoiceDetail?.rententionPercentage
                          ? `(${invoiceDetail.rententionPercentage}%)`
                          : ""}
                        :
                      </span>
                      <span
                        className="fw-bold text-danger"
                        style={{ fontSize: "14.5px" }}
                      >
                        - {formatAmount(invoiceDetail?.rententionAmount)}
                      </span>
                    </div>
                  )}

                  <div
                    className="d-flex align-items-center justify-content-between p-3 rounded-2 mt-1"
                    style={{
                      background: "#eff6ff",
                      border: "1px solid #bfdbfe",
                    }}
                  >
                    <div>
                      <div
                        className="text-uppercase"
                        style={{
                          fontSize: "11px",
                          fontWeight: 700,
                          color: "#1d4ed8",
                          letterSpacing: "0.04em",
                        }}
                      >
                        Net Receivable
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: "11px" }}
                      >
                        Final Billed Gross Amount
                      </div>
                    </div>
                    <div className="text-end">
                      <span
                        className="fw-bold"
                        style={{ fontSize: "1.35rem", color: "#1e40af" }}
                      >
                        {formatAmount(invoiceDetail?.grossAmount) || "--"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Documents & Remarks (2-Column Grid) */}
        <div className="row g-4 mb-4">
          {/* Documents Card */}
          <div className="col-12 col-lg-5">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <div className="d-flex align-items-center gap-2">
                  <span style={{ fontSize: "16px" }}>📄</span>
                  <h5
                    className="mb-0 fw-bold"
                    style={{ fontSize: "14.5px", color: "#0f172a" }}
                  >
                    Bills & Documents
                  </h5>
                </div>
                <span
                  className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill"
                  style={{ fontSize: "11px", fontWeight: 600 }}
                >
                  {invoiceDetail?.documents?.length || 0}
                </span>
              </div>

              <div className="card-body p-4">
                {invoiceDetail?.documents?.length > 0 ? (
                  <div className="d-flex flex-column gap-2.5">
                    {invoiceDetail?.documents?.map((doc, index) => (
                      <div
                        key={index}
                        onClick={() => handleDocumentClick(doc)}
                        className="p-3 rounded-2 d-flex align-items-center justify-content-between cursor-pointer"
                        style={{
                          background: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          cursor: "pointer",
                          transition: "all 0.15s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#f1f5f9";
                          e.currentTarget.style.borderColor = "#cbd5e1";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#f8fafc";
                          e.currentTarget.style.borderColor = "#e2e8f0";
                        }}
                      >
                        <div className="d-flex align-items-center gap-2.5 text-truncate me-2">
                          <div
                            className="rounded-2 p-1.5 d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{ background: "#eff6ff", color: "#2563eb" }}
                          >
                            <DocumentIcon />
                          </div>
                          <span
                            className="fw-semibold text-dark text-truncate"
                            style={{ fontSize: "13px" }}
                            title={doc?.name || "Document"}
                          >
                            {doc?.name || `Document #${index + 1}`}
                          </span>
                        </div>
                        <div
                          className="text-secondary small flex-shrink-0"
                          style={{ fontSize: "11px" }}
                        >
                          {doc?.updatedAt
                            ? moment(doc.updatedAt).format(
                                "DD MMM YYYY | h:mm a"
                              )
                            : "View"}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    className="p-4 rounded-2 text-center text-muted"
                    style={{ border: "2px dashed #e2e8f0" }}
                  >
                    <div style={{ fontSize: "24px", opacity: 0.5 }}>📁</div>
                    <div className="small mt-1 fw-medium">
                      No Documents Attached
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Remarks Card */}
          <div className="col-12 col-lg-7">
            <div
              className="card border-0 shadow-sm rounded-3 h-100"
              style={{ background: "#ffffff" }}
            >
              <div
                className="card-header bg-white py-3 px-4 d-flex align-items-center gap-2 border-bottom"
                style={{ borderColor: "#f1f5f9" }}
              >
                <span style={{ fontSize: "16px" }}>📝</span>
                <h5
                  className="mb-0 fw-bold"
                  style={{ fontSize: "14.5px", color: "#0f172a" }}
                >
                  Remarks
                </h5>
              </div>
              <div className="card-body p-4">
                <div
                  className="p-3 rounded-2"
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    minHeight: "120px",
                    fontSize: "13.5px",
                    color: "#334155",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {invoiceDetail?.remark || "No Remarks Provided..."}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Transactions Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between flex-wrap gap-2 border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                style={{ background: "#f1f5f9", color: "#475569" }}
              >
                <span style={{ fontSize: "15px" }}>💳</span>
              </div>
              <h5
                className="mb-0 fw-bold text-dark"
                style={{ fontSize: "15px" }}
              >
                Transactions
              </h5>
              <span
                className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill ms-1"
                style={{ fontSize: "11.5px", fontWeight: 600 }}
              >
                {invoiceDetail?.transaction?.length || 0}
              </span>
            </div>

            <div className="d-flex align-items-center gap-3 flex-wrap">
              <div
                className="px-3 py-1.5 rounded-pill d-inline-flex align-items-center gap-1.5"
                style={{
                  background: isBalancePending ? "#fff1f2" : "#f0fdf4",
                  border: `1px solid ${
                    isBalancePending ? "#fecdd3" : "#bbf7d0"
                  }`,
                  fontSize: "12px",
                  fontWeight: 600,
                  color: isBalancePending ? "#be123c" : "#15803d",
                }}
              >
                <span>Balance:</span>
                <span className="fw-bold">{formatAmount(balanceAmount)}</span>
              </div>

              {userDetails?.type !== 2 && (
                <button
                  className="btn btn-primary btn-sm d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-1.5 text-white shadow-sm"
                  style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
                  onClick={() => {
                    setEditData("");
                    toggleModal();
                  }}
                >
                  <PlusIcon color="#ffffff" width={11} height={11} />
                  <span>Create Transaction</span>
                </button>
              )}
            </div>
          </div>

          <div className="table-responsive">
            <table
              className="table align-middle mb-0"
              style={{ borderCollapse: "separate", borderSpacing: "0" }}
            >
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Transaction ID
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Date
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Account Holder
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Account No.
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Bank Name
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Reference
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    UTR No.
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Payment Method
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Type
                  </th>
                  <th
                    className="text-end"
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Amount
                  </th>
                  <th
                    className="text-end"
                    style={{
                      width: "90px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {invoiceDetail?.transaction?.length > 0 ? (
                  invoiceDetail?.transaction?.map((item, index) => (
                    <tr
                      key={index}
                      style={{ borderBottom: "1px solid #f1f5f9" }}
                    >
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#334155",
                        }}
                      >
                        {item?.transactionId || "--"}
                      </td>
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          color: "#64748b",
                        }}
                      >
                        {item?.transactionDate
                          ? moment(item.transactionDate).format("DD MMM YYYY")
                          : "--"}
                      </td>
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          color: "#334155",
                        }}
                      >
                        {item?.accountHolderName || "--"}
                      </td>
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          color: "#64748b",
                        }}
                      >
                        {item?.accountNumber || "--"}
                      </td>
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          color: "#64748b",
                        }}
                      >
                        {item?.bankName || "--"}
                      </td>
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          color: "#64748b",
                        }}
                      >
                        {item?.referenceName || "--"}
                      </td>
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          color: "#334155",
                        }}
                      >
                        {item?.utr || "--"}
                      </td>
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          color: "#64748b",
                        }}
                      >
                        {item?.paymentMethod || "--"}
                      </td>
                      <td style={{ padding: "13px 16px" }}>
                        <span
                          className="badge rounded-pill text-capitalize px-2.5 py-1"
                          style={{
                            fontSize: "11.5px",
                            fontWeight: 600,
                            background:
                              item?.type === "credit"
                                ? "#ecfdf5"
                                : item?.type === "debit"
                                ? "#fef2f2"
                                : item?.type === "tds"
                                ? "#eff6ff"
                                : "#fffbeb",
                            color:
                              item?.type === "credit"
                                ? "#059669"
                                : item?.type === "debit"
                                ? "#dc2626"
                                : item?.type === "tds"
                                ? "#2563eb"
                                : "#d97706",
                            border: `1px solid ${
                              item?.type === "credit"
                                ? "#a7f3d0"
                                : item?.type === "debit"
                                ? "#fecaca"
                                : item?.type === "tds"
                                ? "#bfdbfe"
                                : "#fde68a"
                            }`,
                          }}
                        >
                          {item?.type}
                        </span>
                      </td>
                      <td
                        className="text-end"
                        style={{
                          padding: "13px 16px",
                          fontSize: "13.5px",
                          fontWeight: 700,
                          color:
                            item?.type === "credit"
                              ? "#16a34a"
                              : item?.type === "debit"
                              ? "#dc2626"
                              : item?.type === "tds"
                              ? "#2563eb"
                              : "#d97706",
                        }}
                      >
                        {formatAmount(item?.amount)}
                      </td>
                      <td
                        className="text-end"
                        style={{ padding: "13px 16px" }}
                      >
                        <div className="d-flex align-items-center justify-content-end gap-1">
                          <button
                            className="btn btn-sm btn-icon btn-light rounded-circle"
                            style={{
                              width: "30px",
                              height: "30px",
                              padding: 0,
                            }}
                            onClick={() => HandleUpdate(item)}
                            disabled={
                              item?.type === "tds" || item?.type === "due"
                            }
                            title="Edit Transaction"
                          >
                            <EditIcon />
                          </button>
                          <button
                            className="btn btn-sm btn-icon btn-light rounded-circle text-danger"
                            style={{
                              width: "30px",
                              height: "30px",
                              padding: 0,
                            }}
                            onClick={() => ActionHandler(item)}
                            disabled={
                              item?.type === "tds" || item?.type === "due"
                            }
                            title="Delete Transaction"
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center py-5">
                      <div className="d-flex flex-column justify-content-center align-items-center text-muted">
                        <NoRecordIcon />
                        <span className="mt-2 small fw-semibold">
                          No Transactions Found
                        </span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Debit Notes Card */}
        <div
          className="card border-0 shadow-sm rounded-3 mb-4 overflow-hidden"
          style={{ background: "#ffffff" }}
        >
          <div
            className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between flex-wrap gap-2 border-bottom"
            style={{ borderColor: "#f1f5f9" }}
          >
            <div className="d-flex align-items-center gap-2">
              <div
                className="rounded-2 p-1.5 d-flex align-items-center justify-content-center"
                style={{ background: "#f1f5f9", color: "#475569" }}
              >
                <span style={{ fontSize: "15px" }}>📑</span>
              </div>
              <h5
                className="mb-0 fw-bold text-dark"
                style={{ fontSize: "15px" }}
              >
                Debit Notes
              </h5>
              <span
                className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill ms-1"
                style={{ fontSize: "11.5px", fontWeight: 600 }}
              >
                {invoiceDetail?.debitNote?.length || 0}
              </span>
            </div>

            {userDetails?.type !== 2 && (
              <button
                className="btn btn-primary btn-sm d-inline-flex align-items-center gap-1.5 fw-semibold px-3 py-1.5 text-white shadow-sm"
                style={{ background: "#4f46e5", borderColor: "#4f46e5" }}
                onClick={() => {
                  setEditDataForDebitNote("");
                  toggleDebitNoteModal();
                }}
              >
                <PlusIcon color="#ffffff" width={11} height={11} />
                <span>Create Debit Note</span>
              </button>
            )}
          </div>

          <div className="table-responsive">
            <table
              className="table align-middle mb-0"
              style={{ borderCollapse: "separate", borderSpacing: "0" }}
            >
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Debit Note No.
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Date
                  </th>
                  <th
                    className="text-end"
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Amount
                  </th>
                  <th
                    style={{
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Remark
                  </th>
                  <th
                    className="text-end"
                    style={{
                      width: "90px",
                      padding: "12px 16px",
                      fontSize: "11px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#64748b",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {invoiceDetail?.debitNote?.length > 0 ? (
                  invoiceDetail?.debitNote?.map((item, index) => (
                    <tr
                      key={index}
                      style={{ borderBottom: "1px solid #f1f5f9" }}
                    >
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#334155",
                        }}
                      >
                        {item?.transactionId || "--"}
                      </td>
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          color: "#64748b",
                        }}
                      >
                        {item?.transactionDate
                          ? moment(item.transactionDate).format("DD MMM YYYY")
                          : "--"}
                      </td>
                      <td
                        className="text-end"
                        style={{
                          padding: "13px 16px",
                          fontSize: "13.5px",
                          fontWeight: 700,
                          color:
                            item?.type === "credit"
                              ? "#16a34a"
                              : item?.type === "debit"
                              ? "#dc2626"
                              : "#d97706",
                        }}
                      >
                        {formatAmount(item?.amount)}
                      </td>
                      <td
                        style={{
                          padding: "13px 16px",
                          fontSize: "13px",
                          color: "#475569",
                        }}
                      >
                        {item?.remark || "--"}
                      </td>
                      <td
                        className="text-end"
                        style={{ padding: "13px 16px" }}
                      >
                        <div className="d-flex align-items-center justify-content-end gap-1">
                          <button
                            className="btn btn-sm btn-icon btn-light rounded-circle"
                            style={{
                              width: "30px",
                              height: "30px",
                              padding: 0,
                            }}
                            onClick={() => HandleUpdate(item)}
                            title="Edit Debit Note"
                          >
                            <EditIcon />
                          </button>
                          <button
                            className="btn btn-sm btn-icon btn-light rounded-circle text-danger"
                            style={{
                              width: "30px",
                              height: "30px",
                              padding: 0,
                            }}
                            onClick={() => ActionHandler(item)}
                            title="Delete Debit Note"
                          >
                            <DeleteIcon />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <div className="d-flex flex-column justify-content-center align-items-center text-muted">
                        <NoRecordIcon />
                        <span className="mt-2 small fw-semibold">
                          No Debit Notes Found
                        </span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modals */}
      <CreateDebitNoteModal
        modal={debitNoteModal}
        toggle={toggleDebitNoteModal}
        invoiceDetail={invoiceDetail}
        GetInvoiceDetail={GetInvoiceDetail}
        editData={editDataForDebitNote}
      />
      <CreateTransactionModal
        modal={modal}
        toggle={toggleModal}
        invoiceDetail={invoiceDetail}
        GetInvoiceDetail={GetInvoiceDetail}
        editData={editData}
      />
      <ViewDocumentModal
        modal={docModal}
        toggle={toggleDocModal}
        selectedDocument={selectedDocument}
      />
      <ConfirmModal
        modal={deleteModal}
        toggle={toggleDeleteModal}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
      <UpdateBillingDetailsModal
        show={updateBillingModal}
        onClose={toggleUpdateBillingModal}
        invoiceDetail={invoiceDetail}
        GetInvoiceDetail={GetInvoiceDetail}
      />
    </>
  );
}
